import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Menu from "../../components/menu/Menu";
import MenuGeral from "../../components/menu/MenuGeral";

//2025-08-07
//import { getSettings, updateSettings } from "../../services/settingsService";
import { getSettings, updateSettings } from "../../services/userService";
import { getEmpresa, updateEmpresa } from "../../services/empresaService";

function Settings() {

  let decoded = null;
  const isAuth = localStorage.getItem("token") !== null;
  if (isAuth) decoded = jwtDecode(localStorage.getItem("token"));

  const inputEmail = useRef("");
  const inputNewPassword = useRef("");
  const inputConfirmPassword = useRef("");

  const inputNomeEmpresa = useRef("");
  const inputMorada = useRef("");
  const inputCodigoPostal = useRef("");
  const inputLocalidade = useRef("");

  const navigate = useNavigate();

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");

    getSettings(token)
      .then((response) => {
        inputEmail.current.value = response.email;
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");
        setError(err.response ? err.response.data : err.message);
      });

    getEmpresa(token)
      .then((response) => {

        inputNomeEmpresa.current.value = response.designacao;
        inputMorada.current.value = response.morada;

        // inputCodigoPostal.current.value = response.codpostal;

        if (response.codpostal.length === 7) {          
          inputCodigoPostal.current.value = response.codpostal.substring(0,4) + "-" + response.codpostal.substring(4)  
        }
        else {
          inputCodigoPostal.current.value = response.codpostal;
        }

        inputLocalidade.current.value = response.localidade;
      })
      .catch((err) => {
        
        if (err.response && err.response.status === 401) return navigate("/");

        setError(err.response ? err.response.data : err.message);
      });
  }, []);

  function handleFormSubmit(event) {
    event.preventDefault();

    if (
      (inputNewPassword.current.value || inputConfirmPassword.current.value) &&
      inputNewPassword.current.value !== inputConfirmPassword.current.value
    )
      return setError(
        `Os campos 'Nova Senha' e 'Confirmar Senha' devem ser iguais.`
      );

    const token = localStorage.getItem("token");

    updateSettings(
      {
        email: inputEmail.current.value,
        password: inputNewPassword.current.value
          ? inputNewPassword.current.value
          : null,
      },
      token
    )
      .then((result) => {
        if (result) {
          setError("");

          inputNewPassword.current.value = "";
          inputConfirmPassword.current.value = "";
          return setSuccess(`Definições guardadas com sucesso!`);
        } else {
          setSuccess("");
          return setError(`Não é possível atualizar as definições.`);
        }
      })
      .catch((err) => {
        console.error(err.response ? err.response.data : err.message);
        return setError(`Não é possível atualizar as definições.`);
      });

    updateEmpresa(
      {
        morada: inputMorada.current.value,
        localidade: inputLocalidade.current.value,
        codpostal: inputCodigoPostal.current.value,
      },
      token
    )
      .then((result) => {
        if (result) {
          setError("");
          return setSuccess(`Definições guardadas com sucesso!`);
        } else {
          setSuccess("");
          return setError(`Não é possível atualizar as definições.`);
        }
      })
      .catch((err) => {
        console.error(err.response ? err.response.data : err.message);
        return setError(`Não é possível atualizar as definições.`);
      });
  }

  return (
    <>
      { decoded && decoded.isAdmin ? <Menu /> : <MenuGeral />}
      <main className="content">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
          <div className="d-block mb-md-0">
            <h1 className="h4">Definições</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card card-body border-0 shadow mb-4">
              <h2 className="h5 mb-4">Informação sobre o utilizador</h2>
              <form onSubmit={handleFormSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <label htmlFor="email">E-mail</label>
                      <input
                        ref={inputEmail}
                        className="form-control"
                        id="email"
                        type="email"
                        placeholder="utilizador@empresa.pt"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="newPassword">Nova Senha</label>
                      <input
                        ref={inputNewPassword}
                        className="form-control"
                        id="newPassword"
                        type="password"
                        placeholder="Introduza a sua nova senha"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="confirmPassword">Confirmar Senha</label>
                      <input
                        ref={inputConfirmPassword}
                        className="form-control"
                        id="confirmPassword"
                        type="password"
                        placeholder="Introduza a sua nova senha de novo"
                      />
                    </div>
                  </div>
                </div>

                <h2 className="h5 mb-4">Informação sobre a empresa</h2>

                <div className="row">
                  <div className="col-sm-12 mb-3">
                    <div className="form-group">
                      <label htmlFor="nomeEmpresa">Designação</label>
                      <input
                        ref={inputNomeEmpresa}
                        className="form-control"
                        id="nomeEmpresa"
                        type="text"
                        placeholder="Designação"
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 mb-3">
                    <div className="form-group">
                      <label htmlFor="moradaEmpresa">Morada</label>
                      <input
                        ref={inputMorada}
                        className="form-control"
                        id="moradaEmpresa"
                        type="text"
                        placeholder="Morada da empresa"
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="codpostal">Código postal</label>
                      <input
                        ref={inputCodigoPostal}
                        className="form-control"
                        id="codpostal"
                        type="text"
                        placeholder="Código postal"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="localidade">Localidade</label>
                      <input
                        ref={inputLocalidade}
                        className="form-control"
                        id="localidade"
                        type="text"
                        placeholder="Localidade"
                        disabled
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="d-flex justify-content-between flex-wrap flex-md-nowrap">
                    <div className="col-sm-3">
                      <button
                        className="btn btn-gray-800 mt-2 animate-up-2"
                        type="submit"
                      >
                        Guardar
                      </button>
                    </div>
                    {error && (
                      <div className="alert alert-danger mt-2 col-9 py-2">
                        {error}
                      </div>
                    )}
                    {success && (
                      <div className="alert alert-success mt-2 col-9 py-2">
                        {success}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Settings;
